(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultCriticalAlertDialogController', PatientResultCriticalAlertDialogController);

    PatientResultCriticalAlertDialogController.$inject = ['$uibModalInstance', 'criticals'];

    function PatientResultCriticalAlertDialogController($uibModalInstance, criticals) {
        var vm = this;

        vm.clear = clear;
        vm.criticals = criticals;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
